import { Typography } from "@mui/material";
import { MprcJoinComponents } from "components";
import { AssessmentInstanceDto, AssessmentQuestionDto, QuestionType } from "generated/CoreApi_v1";
import { TFunction } from "i18next";
import React from "react";
import { AssPlayerTotalAnswers } from "views/assessment/player/Question/AssPlayerTotalAnswers";

/////////////////////////////////////////////////////////////////////////////////

export const SurveyRevisionAnswersLine = (viewData: AssessmentInstanceDto, question: AssessmentQuestionDto, t: TFunction, deployId?: string) => {
    var items: React.ReactNode[] = [];

    items.push(
        <AssPlayerTotalAnswers
            deployId={deployId}
            viewData={viewData}
            question={question}
        />
    );

    if (question.revision?.identifyAnswers && (question.questionType == QuestionType.MultipleChoice || question.questionType == QuestionType.SimpleChoice)) {
        items.push(
            <Typography variant="caption">
                {t("AssPlayer.Question.Revision.IdentifyAnswersText")}
            </Typography>
        );
    }

    if (question.questionType == QuestionType.MultipleChoice) {
        items.push(
            <Typography variant="caption">
                {t("AssPlayer.Question.Revision.MultipleChoiceText")}
            </Typography>
        );
    }

    return <Typography variant="caption"><MprcJoinComponents components={items} separator={<span>&nbsp;&bull;&nbsp;</span>} /></Typography>;
};
